import React, { useEffect, useState } from 'react';
import { EditPanelDataGrid } from '../../app/common/components/EditPanelDataGrid/EditPanelDataGrid';
import { useTranslation } from 'react-i18next';
import {
  EditDialog,
  EditorModus,
} from '../../app/common/components/EditDialog/EditDialog';
import { on } from 'events';
import {
  getDateFormattedColumn,
  renderReadonlyCheckboxCell,
} from '../../app/helpers/columnHelper';
import { KundeproduktOversikt } from '../../models';
import { GridColDef } from '@mui/x-data-grid-pro';

import { kundeproduktOversiktQueryApiService } from '../../api/rtk-queries/extensions/kundeproduktOversiktQueryApiService';

interface VersjonInformasjonDialogProps {
  open: boolean;
  onClose: () => void;
}
export const VersjonInformasjonDialog: React.FC<
  VersjonInformasjonDialogProps
> = ({ open, onClose }) => {
  const { t } = useTranslation();
  // State for å holde dataene som skal vises i gridet
  const [data, setData] = useState<any[]>([]);
  const [isLoading, setIsLoading] = useState(false);

  // Hent data fra API
  const [hentVersjonsOversiktProdukter] =
    kundeproduktOversiktQueryApiService.useLazyHentProduktVersjonerQuery();

  useEffect(() => {
    if (open) {
      // Kall API når dialogen åpnes
      hentDataFraDB();
    }
  }, [open]);

  async function hentDataFraDB() {
    setIsLoading(true);
    try {
      const result = await hentVersjonsOversiktProdukter().unwrap();
      setData(result); // Oppdater state med resultatet
    } catch (error) {
      console.error('Feil ved henting av data:', error);
    } finally {
      setIsLoading(false);
    }
  }

  let columns: GridColDef[] = [
    {
      field: 'produktNavn',
      headerName: t('Produktnavn'),
      type: 'string',
      width: 250,
      sortable: true,
    },
    {
      field: 'produktVersjon',
      headerName: t('Versjon'),
      type: 'string',
      width: 150,
      sortable: true,
    },
    {
      field: 'oppgradert',
      headerName: t('Oppgradert'),
      width: 150,
      sortable: true,
      cellClassName: 'checkbox--cell',
      renderCell: getDateFormattedColumn,
    },
    // {
    //   field: 'beskrivelse',
    //   headerName: t('Database'),
    //   type: 'string',
    //   width: 150,
    //   sortable: true,
    //   hide: true,
    // },
  ];
  return (
    <EditDialog
      editorModus={EditorModus.Vis}
      open={open}
      testId={'versjon-informasjon-dialog'}
      title={t('Versjonsoversikt')}
      height={600}
      width={985}
      onSave={onClose}
      onCancel={onClose}
      registerNavn={'kundeproduktOversikt'}
      canSave={false}
      hasCloseBtn={true}
      hideSaveBtn={true}
    >
      <div style={{ height: '100%', width: '100%' }}>
        <EditPanelDataGrid
          useRefresh={false}
          enableContextMeny={false}
          testId="kundeprodukt-oversikt-grid"
          gridId="version-overview"
          loading={isLoading}
          columns={columns}
          rows={data ?? []}
          rowHeight={40}
          pageSize={50}
          initialState={{
            sorting: {
              sortModel: [{ field: 'produktNavn', sort: 'asc' }], // Standard sortering på produktNavn i stigende rekkefølge
            },
          }}
          sx={{ height: '100%', width: '100%' }} // Bruker sx for å sette høyde og bredde
        />
      </div>
    </EditDialog>
  );
};

export default VersjonInformasjonDialog;
